import axios, { CancelTokenSource } from "axios"

let balanceSituacionCancelToken: CancelTokenSource | undefined
let perdidasGananciasCancelToken: CancelTokenSource | undefined
let sumasSaldosCancelToken: CancelTokenSource | undefined

const ContabilidadService = {
  fetchBalanceSituacion(queryParam: $TSMigrationFixMe) {
    if (balanceSituacionCancelToken) {
      balanceSituacionCancelToken.cancel("Previous Request Cancelled")
    }
    balanceSituacionCancelToken = axios.CancelToken.source()
    return axios.get(`/BalanceSituacion/by-filters/${queryParam}`, {
      cancelToken: balanceSituacionCancelToken.token,
    })
  },
  fetchPerdidasGanancias(queryParam: $TSMigrationFixMe) {
    if (perdidasGananciasCancelToken) {
      perdidasGananciasCancelToken.cancel("Previous Request Cancelled")
    }
    perdidasGananciasCancelToken = axios.CancelToken.source()
    return axios.get(`/PerdidaGanancia/by-filters/${queryParam}`, {
      cancelToken: perdidasGananciasCancelToken.token,
    })
  },
  fetchSumasSaldos(queryParam: $TSMigrationFixMe) {
    if (sumasSaldosCancelToken) {
      sumasSaldosCancelToken.cancel("Previous Request Cancelled")
    }
    sumasSaldosCancelToken = axios.CancelToken.source()
    return axios.get(`/SumaSaldo/by-filters/${queryParam}`, {
      cancelToken: sumasSaldosCancelToken.token,
    })
  },
  fetchAmortizacionesById(
    id: $TSMigrationFixMe,
    queryParam: $TSMigrationFixMe
  ) {
    return axios.get(`Prestamo/${id}/amortizaciones-by-filters/${queryParam}`)
  },
  createPrestamo(data: $TSMigrationFixMe) {
    return axios.post("/Prestamo", data)
  },
  editPrestamo({ data, id }: $TSMigrationFixMe) {
    return axios.put(`/prestamo/${id}`, data)
  },
  editAmortizaciones({
    prestamoId,
    amortizacionId,
    asientoContableStatus,
  }: $TSMigrationFixMe) {
    return axios.put(
      `/prestamo/${prestamoId}/amortizacion/${amortizacionId}/contabilizar/${asientoContableStatus}`
    )
  },
  editAnotacion({ prestamoId, amortizacionId, body }: $TSMigrationFixMe) {
    return axios.put(
      `/prestamo/${prestamoId}/amortizacion/${amortizacionId}/nota`,
      body,
      {
        headers: {
          "content-type": "application/json",
        },
      }
    )
  },
  createAmortizaciones({ data, prestamoId }: $TSMigrationFixMe) {
    return axios.put(`prestamo/${prestamoId}/amortizacion-anticipada`, data)
  },
  getCuentaContableEmpresa(queryState: $TSMigrationFixMe) {
    return axios.get(`/CuentaContableEmpresa/${queryState}`)
  },
  getPrestamosConciliables(queryParam: $TSMigrationFixMe) {
    return axios.get(`Prestamo/conciliables/${queryParam}`)
  },
}

export default ContabilidadService
